import Ajax from '@utils/ajax';

export default {
  get(q, options = {}) {
    return Ajax.get({
      url: `/autocomplete`,
      data: {
        q: q,
      },
      ...options,
    });
  },
};
